var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 85.58L16.7675 35.6975L21.3025 31.7675L60 76.42L98.6975 31.7675L103.232 35.6975L60 85.58Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9771 60.7507L73.0258 65.2659L97.0239 86.2673L100.975 81.7521L76.9771 60.7507Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0259 60.7377L19.0277 81.7391L22.9791 86.2543L46.9773 65.2529L43.0259 60.7377Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99 93H21C16.0375 93 12 88.9625 12 84V36C12 31.0375 16.0375 27 21 27H99C103.963 27 108 31.0375 108 36V84C108 88.9625 103.963 93 99 93ZM21 33C19.345 33 18 34.345 18 36V84C18 85.655 19.345 87 21 87H99C100.655 87 102 85.655 102 84V36C102 34.345 100.655 33 99 33H21Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage1);
export default __webpack_public_path__ + "static/media/Message-1.69056a61.svg";
export { ForwardRef as ReactComponent };